import { ISaSmsDayStat } from '@interfaces/sa-sms';
import { Card, Empty } from 'antd';
import ReactECharts from 'echarts-for-react';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

/** Daily sent / delivered / failed (30 days, oldest first) from the P16 rollup. */
export const SmsDailyStatsChart: React.FC<{ stats: ISaSmsDayStat[] }> = ({ stats }) => {
    const { t } = useTranslation(['sa-sms']);
    const option = useMemo(() => {
        const days = [...stats].reverse();
        const series = (key: 'sent' | 'delivered', name: string) => ({
            name,
            type: 'bar',
            data: days.map((d) => Number(d[key] ?? 0)),
        });
        return {
            tooltip: { trigger: 'axis' },
            legend: { data: [t('stats.sent'), t('stats.delivered'), t('stats.failed')] },
            grid: { left: 40, right: 16, top: 40, bottom: 30 },
            xAxis: { type: 'category', data: days.map((d) => String(d.day).slice(0, 10)) },
            yAxis: { type: 'value' },
            series: [
                series('sent', t('stats.sent')),
                series('delivered', t('stats.delivered')),
                {
                    name: t('stats.failed'),
                    type: 'line',
                    data: days.map((d) => Number(d.failed ?? 0) + Number(d.undelivered ?? 0)),
                },
            ],
        };
    }, [stats, t]);

    return (
        <Card title={t('detail.stats')}>
            {stats.length === 0 ? (
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('stats.none')} />
            ) : (
                <ReactECharts option={option} style={{ height: 280 }} />
            )}
        </Card>
    );
};
